import { ITooltip } from 'interfaces/components/tooltip';
import { Tooltip } from 'react-tooltip';
import './tooltip.css';

const CustomTooltip = ({
  id,
  icon,
  title,
  content,
  className,
  onClick
}: ITooltip) => {
  return (
    <div>
      <span
        data-tooltip-id={id}
        data-tooltip-html={
          title
            ? `<p class="text-light text-green-700">${title}</p>${content}`
            : content
        }
        data-tooltip-place='top'
      >
        <img className={className} src={icon} alt='' onClick={onClick} />
      </span>
      <Tooltip className='tooltip' place='top' id={id} />
    </div>
  );
};

export default CustomTooltip;
